export default __webpack_public_path__ + "static/media/portfolio-166.28b2e378.jpg";